module.exports = __webpack_public_path__ + "media/testimonials/property-3-3c835a96.jpg";